import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/arr-right.png'


const _withScopeId = n => (_pushScopeId("data-v-6a575c28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cloumn-list-wrapper" }
const _hoisted_2 = { class: "tit-wrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "box" }
const _hoisted_5 = { class: "filter-wrapper" }
const _hoisted_6 = { class: "filter-box filter1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("其他品牌"),
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon",
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_8 = { class: "filter-box filters2" }
const _hoisted_9 = { class: "list-wrapper" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 加载更多 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tab_list = _resolveComponent("tab-list")!
  const _component_custom_btn = _resolveComponent("custom-btn")!
  const _component_series_discount_list = _resolveComponent("series-discount-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.columnImgUrl,
        alt: ""
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_tab_list, {
            class: "brand-tab",
            tabName: '品牌：',
            activeColor: _ctx.activityInfo.subjectRgb,
            list: _ctx.brandList,
            curTabIndex: _ctx.curBrandTabIndex,
            onChangeTabItem: _ctx.changeTabItem
          }, null, 8, ["activeColor", "list", "curTabIndex", "onChangeTabItem"]),
          _createVNode(_component_custom_btn, {
            btnType: 'tab-btn1',
            id: "cxSelect",
            onClick: _ctx.openCarSideBar,
            bgColor: '#ffffff',
            color: '#656565'
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_tab_list, {
            tabName: '价格：',
            activeColor: _ctx.activityInfo.subjectRgb,
            list: _ctx.priceList,
            curTabIndex: _ctx.curPriceTabIndex,
            onChangeTabItem: _ctx.changeTabItem,
            associateTabIndex: _ctx.curBrandTabIndex
          }, null, 8, ["activeColor", "list", "curTabIndex", "onChangeTabItem", "associateTabIndex"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_series_discount_list, {
          list: _ctx.discountList,
          noResult: _ctx.noResult,
          recommendNoResult: _ctx.recommendNoResult,
          isShowLoading: _ctx.isShowLoading
        }, null, 8, ["list", "noResult", "recommendNoResult", "isShowLoading"])
      ]),
      _withDirectives(_createVNode(_component_custom_btn, {
        onClick: _ctx.getMoreData,
        class: "load-more-btn",
        "btn-type": 'load-more',
        bgColor: 'rgba(255,255,255,.5)',
        color: '#656565'
      }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["onClick", "bgColor"]), [
        [_vShow, !_ctx.isShowLoading && _ctx.discountList.length < _ctx.total]
      ])
    ])
  ]))
}